import React from 'react';
import UserSupportTickets from '@/components/support/UserSupportTickets';
import ScorekeeperNav from '@/components/ScorekeeperNav';
import MobileHeader from '@/components/mobile/MobileHeader';
import { MobileFooter } from '@/components/layout/MobileFooter';

const ScorekeeperSupportTickets: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <MobileHeader />
      
      <main className="flex-1 bg-gray-900 text-white p-6 pb-24 overflow-y-auto">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-white mb-2">Support Tickets</h1>
            <p className="text-gray-300">Manage your support requests and track their status</p>
          </div>
          
          <ScorekeeperNav />
          
          <div className="mt-6">
            <UserSupportTickets />
          </div>
        </div>
      </main>
      
      <MobileFooter />
    </div>
  );
};

export default ScorekeeperSupportTickets;